<template>
  <div class="step start step--start">
    <transition name="fade" v-on:after-leave="showSecondSubScreen">
      <div class="start__first-screen" v-if="firstSubScreen">

        <div class="start__title text-uppercase" v-html="$t('start.title')"></div>

        <div class="start__title-image">
          <img :src="$t('start.marsImage')" alt="mars">
        </div>

        <Button :class="'start__first-screen-button'" @click="hideFirstSubScreen(); $emit('startBgMusic')">{{ $t('start.button') }}</Button>
      </div>

    </transition>

    <transition name="fade">

      <div class="start__second-screen" v-if="secondSubScreen">

        <div class="start__text">
          <p v-html="$t('start.text1')"></p>
          <p v-html="$t('start.text2')"></p>
        </div>

        <Button :class="'start__second-screen-button'" @click="next() ">{{ $t('start.button2') }}</Button>
      </div>

    </transition>

  </div>
</template>

<script>

import { mapState } from 'vuex'
import Button from '@/components/global/Button'

export default {
  name: 'StepStart',
  props: {},

  components: {
    Button,
  },

  data () {
    return {
      firstSubScreen: true,
      secondSubScreen: false
    }
  },

  mounted () {
    this.$store.commit('setModel', 0)

    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  created () {},

  updated () {},

  methods: {
    reset() {
      this.firstSubScreen = true
      this.secondSubScreen = false
    },

    next () {
      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-climatize',
          'analytics_label': this.$store.state.step,
        })
      }

      this.$emit('next')
    },

    hideFirstSubScreen () {
      this.firstSubScreen = false
    },

    showSecondSubScreen () {
      this.secondSubScreen = true

      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-start',
          'analytics_label': this.$store.state.step,
        })
      }
    },
  },

  watch: {},

  computed: {
    ...mapState({
      step: state => state.step,
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
